
export const getRequestConfig = async (_options = {}) => {
  return {
    headers: {
      'Content-Type': 'application/json'
    }
  };
};

export function getHostUrl() {
  // This function is generic and works for Azure as well
  return [
    window.location.protocol,
    '//',
    window.location.hostname,
    window.location.hostname === 'localhost' ? ':' + window.location.port : ''
  ].join('');
}